import { c as _c } from "react/compiler-runtime";
import { parseAsBoolean } from "nuqs";
import { usePersistedQueryStates } from "@/src/hooks/use-persisted-query-states";
export function useTaskFilters() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      showCompleted: parseAsBoolean.withDefault(false).withOptions({
        clearOnDefault: false
      })
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return usePersistedQueryStates(t0);
}
export type TaskFilters = ReturnType<typeof useTaskFilters>[0];